import styled from 'styled-components';
import { Placeholder, Text } from '@lmn/design-system';
import { AirlineLogo as SharedAirlineLogo } from '@/app/common/components/AirlineLogo';

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space100};
`;

export const SummaryHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.kallisto.space.space200};
`;

export const SummaryRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space50};
`;

// Rows are top-aligned so that when a label wraps onto extra lines the leading
// icon stays with the first line; the 2px offset centers the 20px icon on the
// Body text's 24px first line, so single-line rows render exactly as the old
// center alignment did.
export const SummaryRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  min-height: 24px;

  > img {
    margin-top: 2px;
  }
`;

// Summary labels show in full, wrapping onto extra lines below their own first
// character (never under the row icon).
export const SummaryRowText = styled(Text).attrs({ variant: 'Body' })`
  min-width: 0;
`;

// A row's one-line loading skeleton. It has no first text line for the row's
// flex-start alignment to sit on, so re-center the 16px skeleton on the 24px
// first line — same idea as the icons' 2px nudge.
export const SummaryRowPlaceholder = styled(Placeholder).attrs({ height: '16px' })`
  margin-top: 4px;
`;

export const TransportLegs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space50};
`;

export const AirlineLogo = styled(SharedAirlineLogo)`
  border-radius: ${({ theme }) => theme.kallisto.border.radius.radius300};
`;

// Same first-line alignment as SummaryRow: the airline logo keeps the first
// line when the leg label wraps on narrow screens. The nudge is hung off the
// logo component itself so that it covers both the image and the span the
// fallback icon renders in, and nothing else the row puts on that line.
export const TransportLeg = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.kallisto.space.space100};

  > ${AirlineLogo} {
    margin-top: 2px;
  }
`;

export const IncludedItemClickable = styled.div.attrs({ role: 'button', tabIndex: 0 })`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;
  gap: ${({ theme }) => theme.kallisto.space.space50};
  width: 100%;
`;
